/**
 * Created by intellicar-rinas on 22/9/17.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import "./LeftPane.css";
import actions from "../../store/actions";
import Dom from "../../helpers/Dom";
import moment from "moment";
// import InDatePicker from "../ReportWindow/schema/InDatePicker/InDatePicker";
import ReportAPIs from "../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../helpers/helperFunctions";
import fenceIcon from "../../assets/images/icon/fence.png";
import carBatteryIcon from "../../assets/images/icon/carBattery.png";
import carBatteryActiveIcon from "../../assets/images/icon/carBattery.active.png";
import signalIcon from "../../assets/images/icon/signal.png";
import signalActiveIcon from "../../assets/images/icon/signal.active.png";
import _ from "lodash";
import { schemaTypes, dateFormat } from "../../constants/constants";
// import mixpanel from "mixpanel-browser";
import GeoCodeAPIs from "../../APIs/GeoCodeAPIs";
import DatePicker from "react-datepicker";
window.showNoGpsFixData = false;
const getLastCommTime = (stats) => {
  // console.log("stats",moment(stats.lasttalkedtime).format("DD-MM-YYYY hh:mm:ss"), stats.lasttalkedtime)
  return stats.lasttalkedtime
    ? moment(stats.lasttalkedtime).format("DD-MM-YYYY hh:mm:ss A")
    : "NA";
};

const getVehicleStatus = (vehicle) => {
  for (let idx in vehicle.filters) {
    if (vehicle.filters[idx] !== "allvehicles") {
      return vehicle.filters[idx];
    }
  }
  return "Unknown";
};

const startTimeTool = {
  key: "starttime",
  type: schemaTypes.DATE_PICKER,
  setIfNull: true,
  model: moment(Date.now()).startOf("day").subtract(1, "days"),
  hideTime: false,
};
const endTimeTool = {
  key: "endtime",
  type: schemaTypes.DATE_PICKER,
  setIfNull: true,
  model: moment(Date.now()).add(1, "day").startOf("day"),
  hideTime: false,
};

export function downloadView(
  allvehicles,
  vehicleMap,
  statsConfig,
  groupTree,
  recentDevices,
  props,
  callback
) {
  window.addrFailed = false;
  const getBatteryHealthStatus = (vehicle) => {
    let bci = _.get(vehicle, "GPS.bci", []).map((f) => f.bucketid);
    if (bci.includes(19)) return "GOOD";
    if (bci.includes(18)) return "AVERAGE";
    if (bci.includes(17)) return "BAD";
    if (bci.includes(12)) return "VERY_BAD";
    return "NOT_AVAILABLE";
  };
  const getMobiliStatus = (mobilistatus) => {
    if (mobilistatus == 0) {
      return "Active";
    } else if (mobilistatus == 1) {
      return "Crank Immobilized";
    } else if (mobilistatus == 2) {
      return "Ignition Immobilized";
    } else if (mobilistatus == 3) {
      return "Crank & Ignition Immobilized";
    }
    return "Unknown";
  };
  let selectedView = [];
  let tempObj;
  let UNKNOWN = "UNKNOWN";
  let group = groupTree.children[0].name;
  let LatLngList = [];
  let splitedLatLng = [];
  let geoloc = [];
  let allAddr = [];
  let allState = [];
  let tempLatLang = [];
  let tempState = []
  let APIcount = 0;
  let geoAPICount = 0;
  let fetchCount = 0;
  let count;
  let path = groupTree.children[0].path;
  let groupids = path.split("/");
  let isAmplus = false;
  for (let idx in groupids) {
    if (parseInt(groupids[idx]) === 1822) {
      isAmplus = true;
    }
  }
  const handleAddressFailure = (error) => {
    APIcount = APIcount + 1;
    props.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Error Fetching Some Recent Locations",
          content: "Unable to fetch a few recent locations",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
    callback()  
  };
  for (let idx in vehicleMap) {
    let vehicle = vehicleMap[idx];
    if (vehicle && "marker" in vehicle) {
      if (window.forceUpdateVehicle(vehicle)) {
        if (group == "TVS_Swiggy") {
          for (let i = 0; i <= vehicle.groups.length - 1; i++) {
            tempObj = {
              ...tempObj,
              ["Group Level " + (i + 1)]: vehicle.groups[i].name,
            };
          }
        } else {
          tempObj = {
            ...tempObj,
            Group: vehicle.groups.map((g) => {
              return g.name;
            }),
          };
        }

        LatLngList.push([vehicle.stats.lat, vehicle.stats.lng]);
        tempObj = {
          // Group: vehicle.groups.map((g) => {
          //   return g.name;
          // }),
          ...tempObj,
          "Vehicle No": vehicle.vehicleno,
          Status: getVehicleStatus(vehicle),
          "DEVICE ID": vehicle.devices.TRACKER
            ? vehicle.devices.TRACKER.deviceno
            : "No Tracker Device",
          "DEVICE TYPE": vehicle.devices.TRACKER
            ? vehicle.devices.TRACKER.devicetype
            : "N/A",
          "Installation Type": vehicle.vehiclemeta.installation_type
            ? vehicle.vehiclemeta.installation_type
            : "NA",
          "Immobilize Type": vehicle.vehiclemeta.immobilize_type
            ? vehicle.vehiclemeta.immobilize_type
            : "NA",
            "Vehicle Type":vehicle.vehicleModel.fueltype ? vehicle.vehicleModel.fueltype : "NA",
          Transmission: vehicle.vehiclemeta.transmission
            ? vehicle.vehiclemeta.transmission
            : "NA",
          OEM: vehicle.vehiclemeta.oem ? vehicle.vehiclemeta.oem : "NA",
          Model: vehicle.vehiclemeta.model ? vehicle.vehiclemeta.model : "NA",
          Variant: vehicle.vehiclemeta.variant
            ? vehicle.vehiclemeta.variant
            : "NA",
          // "KLE ID": vehicle.devices.LOCK_UNLOCK
          //   ? vehicle.devices.LOCK_UNLOCK.deviceno
          //   : "No KLE Device",
          "Chassis No": vehicle.vehiclemeta.chassisno,
          "Last comm time": vehicle.stats.lasttalkedtime
            ? moment(vehicle.stats.lasttalkedtime).format(
                "DD-MM-YYYY hh:mm:ss A"
              )
            : "NA",
          "GPS time":
            vehicle.stats.gpstime != null && vehicle.stats.gpstime != "NA"
              ? moment(vehicle.stats.gpstime).format("DD-MM-YYYY hh:mm:ss A")
              : "NO_GPSTIME",
          "CAN Time":
            vehicle.stats.cantime != null && vehicle.stats.cantime != "NA"
              ? moment(vehicle.stats.cantime).format("DD-MM-YYYY hh:mm:ss A")
              : "NO_CANTIME",
          // "KLE Time":
          //   vehicle.stats.kletime != null && vehicle.stats.kletime != "NA"
          //     ? moment(vehicle.stats.kletime).format(dateFormat)
          //     : "NO_KLETIME",
          // "First Bind Time": vehicle.bindtime ? moment(vehicle.bindtime).format(dateFormat) : "NA",
          "Odometer Calculated From":
            vehicle.vehiclemeta && vehicle.vehiclemeta.odofrom
              ? vehicle.vehiclemeta.odofrom
              : "Not Set",
          "Odometer CAN": isNaN(vehicle.stats.canOdometerFinal)
            ? "NA"
            : vehicle.stats.canOdometerFinal,
          "Odometer GPS": isNaN(vehicle.stats.gpsOdometerFinal)
            ? "NA"
            : vehicle.stats.gpsOdometerFinal,
          "Fuel Level / SOC(%)": vehicle.stats.fuel,
          Mobility: getMobiliStatus(vehicle.stats.mobilistatus),
          Ignition: vehicle.stats.ignitionstatus ? "On" : "Off",
          "Vehicle Battery": vehicle.stats.carbattery,
          "Device Battery": vehicle.stats.devicebattery,
          "CAN Battery Voltage":
            vehicle.stats.batteryVoltage !== null
              ? vehicle.stats.batteryVoltage
              : "N/A",
          Fixquality:
            vehicle.stats.fixquality !== null
              ? vehicle.stats.fixquality
              : "N/A",
          "Device State":
            vehicle.stats.device_state !== null
              ? vehicle.stats.device_state
              : "N/A",
        };
        // if(vehicle.vehicleModel.fueltype === "EV"){
        //   tempObj = {
        //     ...tempObj,
        //     "CAN Battery Voltage" : vehicle.vehicleModel.fueltype === "EV" ? vehicle.stats.batteryVoltage : "NA"
        //   }
        // }
        if(window.userInfo.SELF.enable_source === true) {
          tempObj = {
            ...tempObj,
            "Source": vehicle.vehiclemeta.variant && vehicle.vehiclemeta.variant === "API" ? "API" : "Intellicar"
          }
        }
        if(recentDevices){
          tempObj = {
            ...tempObj,
            "First Bind Time": vehicle.bindtime
              ? moment(vehicle.bindtime).format(dateFormat)
              : "NA",
          };
        }

        if (
          statsConfig
            .map((i) => {
              return i.key;
            })
            .indexOf("badBatteryHealth") !== -1
        ) {
          tempObj = {
            ...tempObj,
            "Battery Status": getBatteryHealthStatus(vehicle),
            "Battery Status Calculated Name": vehicle.batteryHealth
              ? moment(vehicle.batteryHealth.pt).format(dateFormat)
              : "NOT_AVAILABLE",
          };
        }

        tempObj = {
          ...tempObj,
          // DTC: (vehicle.stats.millist && vehicle.stats.millist.length
          //   ? vehicle.stats.millist
          //   : ["NO DTC"]
          // ).join(", "),
          OnRoad: vehicle.vehiclemeta.onroad,
          // "Fitment Location": vehicle.vehiclemeta.fitmentloc,
          // "Last Location": vehicle.stats.address,
          LatLng: vehicle.stats.lat + "," + vehicle.stats.lng,
          // "Docket no": vehicle.vehiclemeta.docketno || "N/A",
          // "Destination Location":
          //   vehicle.vehiclemeta.destination_location || "N/A",
          // Others: vehicle.vehiclemeta.others || "N/A",
          // "CAN Battery Voltage" : vehicle.vehicleModel.fueltype === "EV" ? vehicle.stats.batteryVoltage : "NA",
        };
        if (tempObj.Group.length > 1) {
          let name = "";
          for (let idx in tempObj.Group) {
            name = name + tempObj.Group[idx];
            if (idx < tempObj.Group.length - 1) name = name + "/";
          }
          tempObj.Group = name;
        }
        const evGroup = groupTree.children
          .map((f) => window.evGroups.includes(f.groupid))
          .includes(true);
        if (!evGroup) {
          tempObj = {
            ...tempObj,
            DTC: (vehicle.stats.millist && vehicle.stats.millist.length
              ? vehicle.stats.millist
              : ["NO DTC"]
            ).join(", "),
          };
        }
        if (evGroup) {
          tempObj = {
            ...tempObj,
            "Battery Temperature": vehicle.GPS.battmp || "",
            SOH: vehicle.GPS.soh || "",
            "Charge Cycle": vehicle.GPS.chc || "",
            KWH: vehicle.GPS.kwh || "",
            Current: vehicle.GPS.cr != null ? vehicle.GPS.cr : "N/A",
            "controller Temperature": vehicle.GPS.ctrtmp || "N/A",
          };
        }
        if (isAmplus) {
          tempObj = {
            ...tempObj,
            Speed: vehicle.stats.speed,
          };
        }
        selectedView.push(tempObj);
        // latlngList.push([vehicle.stats.lat, vehicle.stats.lng]);
      }
    }
  }
  const auth = window.getAuth();
  let splitLimit = 50;
  if (LatLngList.length > splitLimit) {
    let startIndex = 0;
    let endindex = startIndex + splitLimit;
    count = Math.ceil(LatLngList.length / splitLimit);
    for (let split = 0; split < count; split++) {
      let page = [];
      for (let idx in LatLngList) {
        if (idx >= startIndex && idx < LatLngList.length && idx < endindex)
          page.push(LatLngList[idx]);
      }
      splitedLatLng.push(page);
      geoloc.push(page)
      startIndex = endindex;
      endindex =
        startIndex + splitLimit > LatLngList.length
          ? LatLngList.length
          : startIndex + splitLimit;
    }
  } else {
    count = 1;
    splitedLatLng[0] = LatLngList;
  }
  const callApis = (body, index) => {
    index = parseInt(index, 10);
    GeoCodeAPIs.getAddress(body).then((resp) => {
      APIcount = APIcount + 1;
      if (resp !== undefined) {
        tempLatLang[index] = resp;
        if (index + 1 < splitedLatLng.length)
          callApis(splitedLatLng[index + 1], index + 1);
      } else {
        let tempArr = [];
        for (let idx in splitedLatLng[index]) {
          tempArr.push([[], "NA"]);
        }
        tempLatLang[index] = tempArr;
        if (index + 1 < splitedLatLng.length)
          callApis(splitedLatLng[index + 1], index + 1);
        if (!window.addrFailed) {
          props.dispatch({
            type: "ADD_INTOAST",
            data: {
              name: "Error Fetching Some Recent Locations",
              content: "Unable to fetch a few recent locations",
              createAt: Date.now(),
              autoClose: 8000,
              showError:true
            },
          });
          window.addrFailed = true;
        }
      }
      if (APIcount === count) {
        tempLatLang.map((data) => {
          allAddr = allAddr.concat(data);
        });
        for (let idx in selectedView) {
          // console.log(allAddr)
          selectedView[idx]["Last Location"] = allAddr[idx][1];
        }
        if(window.userInfo.SELF && window.userInfo.SELF.enable_state_district) {
          getStateLoc(splitedLatLng[0],0)

        }else {
          JSONToCSVConvertor(selectedView, "ViewReport", true);
          callback();
        }
    
      }
    }, handleAddressFailure);
  };
  const getStateLoc = (body, index) => {
    index = parseInt(index, 10);
    let apiBody = {locations : body}
    GeoCodeAPIs.GetGeoLoc(apiBody).then((resp) => {
      geoAPICount = geoAPICount + 1;
      if (resp !== undefined) {
        tempState[index] = resp.data;
        if (index + 1 < splitedLatLng.length)
          getStateLoc(splitedLatLng[index + 1], index + 1);
      } else {
        let tempArr = [];
        for (let idx in splitedLatLng[index]) {
          tempArr.push([[], "NA"]);
        }
        tempState[index] = tempArr;
        if (index + 1 < splitedLatLng.length)
          getStateLoc(splitedLatLng[index + 1], index + 1);
        if (!window.addrFailed) {
          props.dispatch({
            type: "ADD_INTOAST",
            data: {
              name: "Error Fetching Some Recent Locations",
              content: "Unable to fetch a few recent locations",
              createAt: Date.now(),
              autoClose: 8000,
              showError:true
            },
          });
          window.addrFailed = true;
        }
      }
      if (geoAPICount === count) {
        tempState.map((data) => {
          allState = allState.concat(data);
        });
        for (let idx in selectedView) {
          selectedView[idx]["State"] = allState[idx].location?.state || "";
          selectedView[idx]["District"] = allState[idx].location?.district || "";
        }
        JSONToCSVConvertor(selectedView, "ViewReport", true);
        callback();
      }
    }, handleAddressFailure);
  };

  callApis(splitedLatLng[0], 0);

  // JSONToCSVConvertor(selectedView, "ViewReport", true);
}

class LeftPane extends Component {
  imgIconSet = {
    fenceIcon,
    carBatteryIcon,
    carBatteryActiveIcon,
    signalIcon,
    signalActiveIcon,
  };

  constructor(props) {
    super(props);
    window.toggleTableView = false
    window.toggleDevWindow = false
    window.toggleReportWindow = false
    this.hideAlarmMarkers = () => {
      if (window.toggleAlarmMarkers) window.toggleAlarmMarkers(props);
    };
    this.showNoGpsData = (item) => {
      this.setState({ nogpsfix: !this.state.nogpsfix });
      window.showNoGpsFixData = !window.showNoGpsFixData;
    };

    this.toggleReportWindow = () => {
      window.toggleReportWindow = !window.toggleReportWindow
      if(window.toggleReportWindow) {
        window.setReportName = false
      }
      if (window.polyline) window.polyline.setMap(null);
      if (window.startMarker) window.startMarker.setMap(null)
      if (window.endMarker) window.endMarker.setMap(null)
      if (window.pointerMarker) window.pointerMarker.setMap(null)
      
      setTimeout(() => {
        this.props.dispatch({
          type: actions.TOGGLE_REPORT_WINDOW,
        });
      });
    };

    this.toggleRTGPS = () => {
      setTimeout(() => {
        this.props.dispatch({
          type: actions.TOGGLE_RTGPS,
        });
      });
    };

    this.locations = window.locations;

    this.setLocation = (item) => {
      // mixpanel.track("User Selects " + item.name + " Location", {
      //   Platform: "Web",
      //   Application: "Web",
      //   Screen: "Navigation",
      // });
      if (
        item.icon in this.locations &&
        window.map &&
        !this.props.freezMap.active
      ) {
        window.map.setCenter(this.locations[item.icon]);
        window.map.setZoom(11);
      }
    };

    window.setLocationByTag = (tag) => {
      this.setLocation(this.locations[tag]);
    };

    window.zoomToFitView = this.zoomToFitView = () => {
      // mixpanel.track("User Sets Map To Fit View", {
      //   Platform: "Web",
      //   Application: "Web",
      //   Screen: "Navigation",
      // });
      let bounds = new window.google.maps.LatLngBounds();
      let results = [];
      let pos;
      for (let idx in this.props.vehicleMap) {
        if (
          this.props.vehicleMap[idx].marker &&
          window.forceUpdateVehicle(this.props.vehicleMap[idx])
        ) {
          pos = this.props.vehicleMap[idx].marker.getPosition();
          //lat -85.05115  to +85.05115
          //lng -180 to +180
          if (pos && (pos.lat() !== 0 || pos.lng() !== 0)) {
            if (
              pos.lat() > -85.05115 &&
              pos.lat() < 85.05115 &&
              pos.lng() > -180 &&
              pos.lng() < 180
            ) {
              bounds.extend(pos);
              results.push(pos);
            }
          }
        }
      }
      if (this.props.freezMap.active) return;

      if (results.length > 1) {
        window.map.fitBounds(bounds);
        window.map.panToBounds(bounds);
      } else {
        window.map.setCenter(results[0]);
        window.map.setZoom(17);
      }
    };

    this.downloadView = (item) => {
      // mixpanel.track("User Clicks on Download View", {
      //   Platform: "Web",
      //   Application: "Web",
      //   Screen: "Navigation",
      // });
      item.busy = true;
      this.forceUpdate();
      downloadView(
        Object.keys(this.props.vehicleMap),
        this.props.vehicleMap,
        this.props.statsConfig,
        this.props.groupTree,
        null,
        props,
        () => {
          item.busy = false;
        }
      );
      // item.busy = false;
      this.forceUpdate();
    };

    this.setGeoFilter = (item) => {
      let data = {};
      data[item.params] = !this.props.geofenceFilters.data[item.params];
      this.props.dispatch({
        type: actions.GEOFENCE_FILTER_UPDATED,
        data: {
          data,
          updatedAt: Date.now(),
        },
      });
    };

    this.toggleSelectAllGeoFilter = () => {
      let status = !this.isAllGeoFiltersActive();
      let data = {};
      for (let idx in this.props.geofenceFilters.data) {
        data[idx] = status;
        if (idx === "citylimit") data[idx] = false;
      }
      this.props.dispatch({
        type: actions.GEOFENCE_FILTER_UPDATED,
        data: {
          data,
          updatedAt: Date.now(),
        },
      });
    };

    this.isAllGeoFiltersActive = () => {
      let counter = 0;
      for (let idx in this.props.geofenceFilters.data) {
        if (
          this.props.geofenceFilters.data.parking === true &&
          this.props.geofenceFilters.data.servicestation === true &&
          this.props.geofenceFilters.data.competitor === true &&
          this.props.geofenceFilters.data.tollplaza === true
        ) {
          return true;
        } else return false;
      }
    };

    this.toggleOverlayFilter = (item) => {
      let data = {};
      data[item.params] = !this.props.overlayFilters.data[item.params];
      this.props.dispatch({
        type: actions.OVERLAY_FILTER_UPDATED,
        data: {
          data,
          updatedAt: Date.now(),
        },
      });
    };

    this.downloadGeoView = (item) => {
      console.log("calling.");
      // mixpanel.track("User " + item.name, {
      //   Platform: "Web",
      //   Application: "Web",
      //   Screen: "Navigation",
      // });
      let vehicle;
      let list = [];
      let geofences = this.props.geofenceMap;
      item.busy = true;
      this.forceUpdate();

      let params = item.params;

      if (typeof params == "string") {
        params = [params];
      }

      if (!geofences) return;

      for (let idx in this.props.vehicleMap) {
        vehicle = this.props.vehicleMap[idx];
        for (let jdx in geofences.data) {
          for (let kdx in params) {
            if (
              geofences &&
              geofences.data[jdx].polygon &&
              geofences.data[jdx].info.type === params[kdx] &&
              vehicle.stats &&
              vehicle.showable &&
              geofences.data[jdx].polygon.containsLatLng &&
              geofences.data[jdx].polygon.containsLatLng(
                new window.google.maps.LatLng(
                  vehicle.stats.lat,
                  vehicle.stats.lng
                )
              )
            ) {
              list.push({
                "Geofence Name": geofences.data[jdx].name,
                "Vehicle Model": vehicle.vehiclemeta
                  ? vehicle.vehiclemeta.model
                  : "No Data",
                "Vehicle No": vehicle.vehicleno,
                "Device ID": vehicle.devices.TRACKER
                  ? vehicle.devices.TRACKER.deviceno
                  : vehicle.devices.LOCK_UNLOCK
                  ? vehicle.devices.LOCK_UNLOCK.deviceno
                  : "No Data",
                "Last Talk Time": getLastCommTime(vehicle.stats),
              });
            }
          }
        }
      }
      JSONToCSVConvertor(list, "ViewReport", true);
      item.busy = false;
      this.forceUpdate();
    };

    this.toggleGroupWindow = () => {
      this.props.dispatch({
        type: actions.TOGGLE_LEFT_TREE,
        data: this.props.leftTree ? 0 : 1,
      });
    };

    this.toggleImmobView = (item) => {
      window.toggleTableView = !window.toggleTableView
      
      this.props.dispatch({
        type: actions.TOGGLE_BULK_IMMOB,
        data: { active: !this.props.bulkImmob.active },
      });
    };
    this.toggleTableView = (item) => {
      window.toggleTableView = !window.toggleTableView
      if(window.toggleTableView) {
        document.title =  "Track - Live Table"
      }else {
        document.title =  "Track"
      }
      this.props.dispatch({
        type: actions.TOGGLE_TABLE_VIEW,
        data: { active: !this.props.tableView.active },
      });
    };
    this.toggleLastLoc = (item) => {
      this.props.dispatch({
        type: actions.TOGGLE_LASTLOC,
        data: { active: !this.props.lastLoc.active },
      });
    };
    this.toggleMute = (item) => {
      this.props.dispatch({
        type: actions.TOGGLE_MUTE,
        data: { active: !this.props.muteAudio.active },
      });
    };

    this.downloadOneDayReport = (item) => {
      if (this.state.downloadProgress || this.state.errorDate) {
        return;
      }
      if (this.starttimeStamp >= this.endtimeStamp) {
        props.dispatch({
          type: "ADD_INTOAST",
          data: {
            name: "Download Failed",
            content: "The start time should be less than the end time",
            createAt: Date.now(),
            autoClose: 8000,
            showError:true
          },
        });
        return;
      }
      this.setState({
        oneDayReportVisible: false,
        downloadProgress: true,
      });

      // mixpanel.track("User Downloads Distance Report", {
      //   Platform: "Web",
      //   Application: "Web",
      //   Screen: "Navigation",
      // });
      let vehicles = [];
      this.forceUpdate();
      for (let idx in this.props.vehicleMap) {
        let vehicle = this.props.vehicleMap[idx];
        if (vehicle && "marker" in vehicle) {
          if (window.forceUpdateVehicle(vehicle)) {
            vehicles.push(vehicle);
          }
        }
      }

      let body = {
        vehicleid: vehicles.map((v) => {
          return v.vehicleid;
        }),
        starttime: moment(this.state.startTimeText).unix() * 1000,
        endtime: moment(this.state.endTimeText).unix() * 1000,
      };

      // console.log(body);

      let handleDayReportSuccess = (resp) => {
        // console.log(resp);
        let jData = [];
        let vehicle;
        let vehicleMap = {};
        for (let idx in vehicles) {
          vehicleMap[vehicles[idx].vehicleid] = vehicles[idx];
        }

        jData.push({
          "Start Time": moment(this.state.startTimeText).format("DD-MM-YYYY"),
          "End Time": moment(this.state.endTimeText).format("DD-MM-YYYY"),
        });
        jData.push({});
        jData.push({
          "Vehicle No": "Vehicle No",
          Distance: "Distance",
          // Status: "Status",
          // "Last Odometer": "Last Odometer",
        });

        for (let path in resp) {
          vehicle = vehicleMap[path];

          if (!vehicle) continue;

          jData.push({
            "Vehicle No": vehicle.vehicleno,
            Distance: resp[path].distance,
            // Status: resp[path].status,
            // "Last Odometer":
            //   resp[path].odometer != null ? resp[path].odometer : "-",
          });
        }
        JSONToCSVConvertor(jData, "Distance Report");
        this.setState({
          downloadProgress: false,
        });
      };

      let handleDayReportFailure = () => {
        this.props.dispatch({
          type: actions.TOGGLE_TABLE_VIEW,
          data: { active: !this.props.freezMap },
        });
        this.setState({
          downloadProgress: false,
        });
      };
      ReportAPIs.getVehicleSummary(body).then(
        handleDayReportSuccess,
        handleDayReportFailure
      );
    };

    this.toggleFreezMap = () => {
      this.props.dispatch({
        type: actions.TOGGLE_FREEZ_MAP,
        data: { active: !this.props.freezMap.active },
      });
    };

    this.downloadGeoLatLng = () => {
      let data = [];
      let item;

      for (let idx in this.props.geofenceMap.data) {
        item = this.props.geofenceMap.data[idx];
        if (!item.info) continue;

        data.push({
          Name: item.name,
          Type: item.info.type,
          Structure: item.info.structure,
          Center:
            item.info.structure === "circle"
              ? item.info.center.lat + "," + item.info.center.lng
              : "-",
          Radius: item.info.structure === "circle" ? item.info.radius : "-",
          Coords:
            item.info.structure !== "circle"
              ? item.info.coords
                  .map((i) => {
                    return "[" + i.lat + "," + i.lng + "]";
                  })
                  .join(",")
              : "-",
        });
      }
      JSONToCSVConvertor(data, "All Geofence LatLngs");
    };

    /*
     *
     *  Dynamic Geofence
     *
     * */

    this.toggleDGeofence = () => {
      if (!window.map) return;

      let active = !this.props.DGeofence.active;

      this.props.dispatch({
        type: actions.SET_DGEOFENCE_MODE,
        data: { active },
      });
    };

    this.toggleLatestDevWindow = () => {
      window.toggleDevWindow = !window.toggleDevWindow
      if(window.toggleDevWindow) {
        document.title = "Track - Installation Info"
      }else {
        document.title = "Track"
      }
      this.props.dispatch({
        type: actions.TOGGLE_RECENT_DEVICES,
        data: this.props.recentDevices ? 0 : 1,
      });
    };

    this.startTimeFunc = (val) => {
      this.starttimeStamp = moment(val).unix() * 1000;
      val._i = moment(val._i).startOf("day").format("DD-MMM-YYYY");
      this.setState({
        startTimeText: moment(val),
      });
    };

    this.endTimeFunc = (val) => {
      this.endtimeStamp = moment(val).unix() * 1000;
      val._i = moment(val._i).startOf("day").format("DD-MMM-YYYY");

      this.setState({
        endTimeText: moment(val),
      });
      this.starttimeStamp = this.state.startTimeText.unix() * 1000;
      if (this.starttimeStamp > this.endtimeStamp) {
        this.setState({
          errorDate: true,
          downloadProgress: true,
        });
      } else {
        this.setState({
          errorDate: false,
          downloadProgress: false,
        });
      }
    };

    this.state = {
      oneDayReportVisible: false,
      errorDate: false,
      startTimeText: moment(Date.now()).startOf("day").subtract(1, "days"),
      endTimeText: moment(),
      downloadProgress: false,
      nogpsfix: false,
      leftPane: [
        {
          name: "Open Group Tree",
          key: "group_tree_button",
          nameActive: "Close Group Tree",
          onClick: this.toggleGroupWindow,
          overrideVisibility: (item) => {
            return true;
          },
          icon: "fa fa-chevron-right",
          iconActive: "fa fa-chevron-left",
          isActive: () => {
            return this.props.leftTree;
          },
        },
        {
          name: "Reports",
          key: "reports",
          onClick: this.toggleReportWindow,
          icon: "fa fa-line-chart",
          isActive: () => {
            return this.props.reportWindow.visible;
          },
        },
        {
          name: "Zoom to fit View",
          key: "zoom_to_fit",
          historyMap: false,
          onClick: this.zoomToFitView,
          icon: "fa fa-crosshairs",
        },
        { type: "separator" },
        {
          icon: "fa fa-map-marker",
          name: "Locations",
          key: "locations",
          historyMap: false,
          children: [
            {
              name: "User",
              onClick: this.setLocation,
              iconType: "text",
              icon: "USR",
            },
            {
              name: "Banglore",
              onClick: this.setLocation,
              iconType: "text",
              icon: "BLR",
            },
            {
              name: "Mumbai",
              onClick: this.setLocation,
              iconType: "text",
              icon: "MUM",
            },
            {
              name: "Hyderbad",
              onClick: this.setLocation,
              iconType: "text",
              icon: "HYD",
            },
            {
              name: "Pune",
              onClick: this.setLocation,
              iconType: "text",
              icon: "PUN",
            },
            {
              name: "Delhi",
              onClick: this.setLocation,
              iconType: "text",
              icon: "DEL",
            },
            {
              name: "Chennai",
              onClick: this.setLocation,
              iconType: "text",
              icon: "CHE",
            },
            {
              name: "Kolkata",
              onClick: this.setLocation,
              iconType: "text",
              icon: "KOL",
            },
            {
              name: "Jaipur",
              onClick: this.setLocation,
              iconType: "text",
              icon: "JPR",
            },
            {
              name: "Lucknow",
              onClick: this.setLocation,
              iconType: "text",
              icon: "LKO",
            },
            {
              name: "Kochi",
              onClick: this.setLocation,
              iconType: "text",
              icon: "COK",
            },
          ],
        },
        {
          iconType: "img",
          icon: this.imgIconSet.fenceIcon,
          key: "geofence",
          name: "Geofences",
          historyMap: false,
          children: [
            {
              name: "Show All",
              isActive: () => {
                return this.isAllGeoFiltersActive();
              },
              onClick: this.toggleSelectAllGeoFilter,
              icon: "fa fa-eye",
            },
            {
              name: "Parking Lot",
              params: "parking",
              isActive: () => {
                return this.props.geofenceFilters.data.parking;
              },
              onClick: this.setGeoFilter,
              icon: "fa fa-product-hunt",
            },
            {
              name: "Service Station",
              params: "servicestation",
              onClick: this.setGeoFilter,
              isActive: () => {
                return this.props.geofenceFilters.data.servicestation;
              },
              icon: "fa fa-wrench",
            },
            {
              name: "Competitor Hub",
              params: "competitor",
              onClick: this.setGeoFilter,
              isActive: () => {
                return this.props.geofenceFilters.data.competitor;
              },
              icon: "fa fa-ban",
            },
            {
              name: "City Limits",
              params: "citylimit",
              onClick: this.setGeoFilter,
              isActive: () => {
                return this.props.geofenceFilters.data.citylimit;
              },
              icon: "fa fa-road",
            },
            {
              name: "Refresh Geofence",
              icon: "fa fa-globe",
            },
          ],
        },

        {
          isBusy: (item) => {
            return !this.props.gotAllBuckets || item.busy;
          },
          historyMap: false,
          key: "downloads",
          name: "Downloads",
          icon: "fa fa-circle-down",
          children: [
            {
              icon: "fa fa-product-hunt",
              isBusy: (item) => {
                return item.busy;
              },
              onClick: this.downloadGeoView,
              params: "parking",
              name: "Download Vehicle in Parking Lot",
            },
            {
              icon: "fa fa-wrench",
              isBusy: (item) => {
                return item.busy;
              },
              onClick: this.downloadGeoView,
              params: "servicestation",
              name: "Download Vehicle in Service Centers",
            },
            {
              icon: "fa fa-eye",
              isBusy: (item) => {
                return item.busy;
              },
              onClick: this.downloadGeoView,
              params: ["parking", "servicestation"],
              name: "Download Vehicle in Parking Lots and Service Centers",
            },
            {
              icon: "fa fa-globe",
              isBusy: (item) => {
                return item.busy;
              },
              onClick: this.downloadGeoLatLng,
              name: "Download All Geofence LatLngs",
            },
          ],
        },
        { type: "separator" },
        // {
        //   icon: "fa fa-exclamation-triangle",
        //   key: "alarm_button",
        //   name: "Alarm",
        //   isBusy: (item) => {
        //     return !this.props.gotAllBuckets || item.busy;
        //   },
        //   historyMap: false,
        //   children: [
        //     {
        //       name: "Low Device Battery",
        //       isActive: () => {
        //         return this.props.overlayFilters.data.lowDB;
        //       },
        //       onClick: this.toggleOverlayFilter,
        //       params: "lowDB",
        //       icon: "fa fa-battery-quarter",
        //     },
        //     {
        //       name: "Low Vehicle Battery",
        //       iconType: "img",
        //       isActive: () => {
        //         return this.props.overlayFilters.data.lowVB;
        //       },
        //       onClick: this.toggleOverlayFilter,
        //       params: "lowVB",
        //       icon: this.imgIconSet.carBatteryIcon,
        //       iconActive: this.imgIconSet.carBatteryActiveIcon,
        //     },
        //     {
        //       name: "Vehicle Not Communicating",
        //       iconType: "img",
        //       isActive: () => {
        //         return this.props.overlayFilters.data.noComm;
        //       },
        //       onClick: this.toggleOverlayFilter,
        //       params: "noComm",
        //       icon: this.imgIconSet.signalIcon,
        //       iconActive: this.imgIconSet.signalActiveIcon,
        //     },
        //   ],
        // },
        {
          name: "Vehicle Number",
          icon: "fa fa-car",
          key: "vehicle_number_button",
          onClick: this.toggleOverlayFilter,
          isBusy: (item) => {
            return !this.props.gotAllBuckets || item.busy;
          },
          isActive: () => {
            return this.props.overlayFilters.data.vehNo;
          },
          params: "vehNo",
          historyMap: false,
        },
        { type: "separator" },
        {
          name: "Download View",
          key: "download_view",
          historyMap: false,
          isBusy: (item) => {
            return !this.props.gotAllBuckets || item.busy;
          },
          onClick: this.downloadView,
          icon: "fa fa-download",
        },
        {
          name: "One Day Distance Report",
          key: "one_day_distance_report",
          icon: "fa fa-cloud-download",
          onClick: this.downloadOneDayReport,
          defaultValue: 4,
          type: "ONE_DAY_REPORT",
          historyMap: false,
        },
        { type: "separator" },
        {
          name: "Start Realtime Data",
          key: "toggle_real_time",
          nameActive: "Stop Realtime Data",
          onClick: this.toggleRTGPS,
          icon: "fa fa-play",
          iconActive: "fa fa-stop",
          historyMap: false,
          isActive: () => {
            return this.props.RTGPS;
          },
        },
        {
          name: "Create Dynamic Geofence",
          key: "create_dynamic_geofence",
          icon: "fa fa-pencil",
          onClick: this.toggleDGeofence,
          isActive: () => {
            return this.props.DGeofence.active;
          },
          historyMap: false,
        },
        {
          name: "Lock Map",
          nameActive: "Unlock Map",
          key: "lock_map",
          icon: "fa fa-lock",
          iconActive: "fa fa-unlock",
          onClick: this.toggleFreezMap,
          isActive: () => {
            return this.props.freezMap.active;
          },
          historyMap: false,
        },
        {
          name: "Table View",
          key: "table_view",
          icon: "fa fa-list",
          isActive: () => {
            return this.props.tableView.active;
          },
          onClick: this.toggleTableView,
          historyMap: false,
        },
        {
          name: "Toggle alarm",
          key: "toggle_alarm",
          icon: "fa fa-eye-slash",
          onClick: this.hideAlarmMarkers,
          historyMap: true,
          isActive: () => this.props.showAlarms,
          mainMap: false,
        },
        {
          name: "Toggle Last Location",
          key: "last_loc",
          icon: "fa-solid fa-location-dot",
          isActive: () => {
            return this.props.lastLoc.active;
          },
          onClick: this.toggleLastLoc,
          historyMap: false,
        },
        { type: "separator" },
        {
          name: "Installation Info",
          key: "installation_info",
          onClick: this.toggleLatestDevWindow,
          icon: "fa fa-circle-info",
          iconActive: "fa fa-circle-info",
          isBusy: (item) => {
            return !this.props.gotAllBuckets || item.busy;
          },
          isActive: () => {
            return this.props.recentDevices;
          },
          historyMap: false,
        },
        {
          name: "Mute Audio",
          key: "mute_audio",
          icon: "fa-solid fa-volume-xmark",
          isActive: () => {
            return this.props.muteAudio.active;
          },
          onClick: this.toggleMute,
          historyMap: false,
        },
        {
          name: "show no gps fix data",
          key: "show_gps_fix_data",
          icon: "fa-solid fa-location-dot",
          onClick: this.showNoGpsData,
          hideGps: false,
          isActive: (item) => {
            return this.state.nogpsfix;
          },
          mainMap: false,
        },
        {
          name: "Bulk Immob",
          key: "bulk_immob",
          icon: "fa-solid fa-layer-group",
          isActive: () => {
            return this.props.bulkImmob.active;
          },
          onClick: this.toggleImmobView,
          historyMap: false,
        },
        { type: "separator" },
      ],
    };

    this.getIcon = (item) => {
      let icon = item.icon;
      if (this.isActive(item) && item.iconActive) {
        icon = item.iconActive;
      }

      switch (item.iconType) {
        case "img":
          return <img alt="" src={icon} />;

        case "text":
          return <span className="lpbi-text-icon">{icon}</span>;

        default:
          return <i className={icon}></i>;
      }
    };

    this.getName = (item) => {
      if (this.isActive(item) && item.nameActive) {
        return item.nameActive;
      }
      return item.name;
    };

    this.isVisible = (item) => {
      if (item.overrideVisibility && !item.overrideVisibility(item)) {
        return false;
      }

      if (!this.props.reportWindow.visible) {
        if ("hideGps" in item) {
          return false;
        }
      } else {
        if ("hideGps" in item) {
          return true;
        }
      }
      if (this.props.reportWindow.visible) {
        if ("historyMap" in item) {
          return item.historyMap;
        }
        return true;
      } else {
        if ("mainMap" in item) {
          return item.mainMap;
        }
        return true;
      }
    };

    this.isActive = (item) => {
      if ("isActive" in item) {
        return item.isActive();
      }
      return false;
    };

    this.onClick = (item) => {
      if ("onClick" in item && item.type !== "ONE_DAY_REPORT") {
        item.onClick(item);
      }
      if (item.type === "ONE_DAY_REPORT") {
        this.setState({
          oneDayReportVisible: this.state.oneDayReportVisible ? false : true,
        });
      }
    };
    this.onReportClick = (item) => {
      if (item.type === "ONE_DAY_REPORT")
        this.setState({
          oneDayReportVisible: true,
        });
    };

    this.isBusy = (item) => {
      if ("isBusy" in item) {
        return item.isBusy(item);
      }
      return false;
    };

    this.onOneDayInputChange = (item) => {
      if (item.ref) {
        let val = item.ref.value;
        val = parseInt(val);
        if (!isNaN(val)) {
          if (val < 0) {
            item.ref.value = 0;
          } else if (val > 23) {
            item.ref.value = 23;
          }
        }
        item.value = item.ref.value;
      }
      this.forceUpdate();
    };

    this.getOneDayReportDesc = (item) => {
      if (!this.state.oneDayReportVisible) {
        return "One Day Distance report";
      }

      if (this.state.errorDate) {
        return "End date must be greater than start date";
      }

      if (
        moment(this.state.startTimeText).format("DD-MM-YYYY").length > 0 &&
        moment(this.state.endTimeText).format("DD-MM-YYYY").length > 0
      ) {
        return (
          moment(this.state.startTimeText).format("DD-MM-YYYY") +
          " to " +
          moment(this.state.endTimeText).format("DD-MM-YYYY") +
          " Distance Report"
        );
      }
    };
  }

  filterLeftPane = (item) => {
    let disabledButtons =
      (window.userInfo.SELF || {}).disabled_track_leftpane_buttons || [];
      if (this.props.reportWindow.visible && item.type === "separator") {
        return false;
      }     
      if(item.key === "bulk_immob") {
        if(window.userInfo.SELF.enable_bulk_immob){
          return true
        }else return false
      }
    return disabledButtons.indexOf(item.key) === -1;
  };

  render() {
    return (
      <div className="LeftPane">
        {this.state.leftPane.filter(this.filterLeftPane).map((item, index) => {
          return item.type === "separator" ? (
            <div className="lp-separator" key={index}></div>
          ) : this.isVisible(item) ? (
            <div
              key={index}
              className={Dom.Class(
                { active: this.isActive(item), busy: this.isBusy(item) },
                "lp-button"
              )}
            >
              {this.isBusy(item) ? (
                <div className="lpb-busy">
                  <span className="lpbb-spinner"></span>
                </div>
              ) : null}
              {item.type === "ONE_DAY_REPORT" ? (
                <div
                  className={
                    "lpb-container " +
                    (this.state.oneDayReportVisible
                      ? "oneDayReportVisible"
                      : "")
                  }
                  onClick={() => this.onReportClick(item)}
                >
                  <div className="lpbc-oneday">
                    <DatePicker
                      onChange={this.startTimeFunc}
                      selected={this.state.startTimeText ? (this.state.startTimeText).unix()*1000 : Date.now()}
                      dateFormat="dd-MM-yyyy"
                      // data={startTimeTool}
                    />
                    <DatePicker
                      onChange={this.endTimeFunc}
                      selected={this.state.endTimeText ? (this.state.endTimeText).unix()*1000 : Date.now()}
                      dateFormat="dd-MM-yyyy"
                      // data={endTimeTool}
                    />
                    <div
                      className={
                        "lpbco-button " +
                        (this.state.downloadProgress ? "disableDownload" : "")
                      }
                      onClick={() => item.onClick(item)}
                    >
                      DOWNLOAD
                    </div>
                  </div>
                  <div
                    className={
                      "lpbco-desc " +
                      (this.state.oneDayReportVisible
                        ? "onedayreportdesc"
                        : "") +
                      (this.state.errorDate && this.state.oneDayReportVisible
                        ? " errordate"
                        : "")
                    }
                  >
                    {this.getOneDayReportDesc(item)}
                  </div>
                </div>
              ) : null}
              <div
                className={
                  "lpb-icon" +
                  (item.type === "ONE_DAY_REPORT" &&
                  this.state.oneDayReportVisible
                    ? " redIcon"
                    : "")
                }
                onClick={() => this.onClick(item)}
              >
                {this.getIcon(item)}
                {item.type !== "ONE_DAY_REPORT" ? (
                  this.getName(item) ? (
                    <div
                      className={
                        "lpbi-name lpbi-name-main " +
                        (item.children ? " -parent" : "")
                      }
                      style={{
                        minWidth: item.children
                          ? item.children.length * 44 - 4
                          : 0,
                      }}
                    >
                      {this.getName(item)}
                    </div>
                  ) : null
                ) : null}
              </div>
              {item.children ? (
                <div className="lpb-container">
                  {item.children.map((child, index2) => {
                    return this.isVisible(child) ? (
                      <div
                        key={index2}
                        onClick={() => this.onClick(child)}
                        className={Dom.Class(
                          { active: this.isActive(child) },
                          "lpb-child-icon"
                        )}
                      >
                        {this.getIcon(child)}
                        {this.getName(child) ? (
                          <div className="lpbi-name">{this.getName(child)}</div>
                        ) : null}
                      </div>
                    ) : null;
                  })}
                </div>
              ) : null}
            </div>
          ) : null;
        })}
      </div>
    );
  }
}

const MapPropsToState = (state) => {
  return {
    reportWindow: state.reportWindow,
    RTGPS: state.RTGPS,
    stats: state.stats,
    vehicleMap: state.vehicleMap,
    gotAllBuckets: state.gotAllBuckets,
    geofenceFilters: state.geofenceFilters,
    overlayFilters: state.overlayFilters,
    geofenceMap: state.geofenceMap,
    leftTree: state.leftTree,
    tableView: state.tableView,
    freezMap: state.freezMap,
    DGeofence: state.DGeofence,
    recentDevices: state.recentDevices,
    groupTree: state.groupTree,
    showAlarms: state.showAlarms,
    lastLoc: state.lastLoc,
    muteAudio: state.muteAudio,
    bulkImmob:state.bulkImmob,
  };
};

export default connect(MapPropsToState)(LeftPane);
